import * as React from "react";
import { Box, Typography, Divider, Link, useMediaQuery } from "@mui/material";
import FacebookIcon from '@mui/icons-material/Facebook';
import logo from '../../assets/icons/logo.png';
import email from '../../assets/icons/email.png';
import phone from '../../assets/icons/phone.png';
import locationIcon from '../../assets/icons/location.png';
import tiktokIcon from '../../assets/icons/tiktok.svg';
import googleMapsIcon from '../../assets/icons/google-maps.svg';
import theme from '../../theme';

const address =
  "အမှတ် 108 ၊ 25 လမ်း 83x84 ကြား ၊ အောင်မြေသာဇံမြို့နယ် ၊ မန္တလေးမြို့ ။";
const businessHours =
  "9:00 AM to 5:00 PM";
const closedNotes =
  "ဥပုသ်နေ့တိုင်း နေ့တစ်ပိုင်း ပိတ်ပါသည်။ လစဉ် လပြည့်နေ့တိုင်း ဆိုင်ပိတ်ပါသည်။";
const contactNumbers = [
  "02-4067233",
  "02-4067234",
  "02-4065567",
  "02-4039110",
  "02-4039319",
  "09-782004472",
  "09-964065567",
  "09-404040577",
  "09-404040677",
  "09-952009123",
];
const viberInviteLink =
  "https://invite.viber.com/?g2=AQAcvOWA6No9dk73hnxYyJsEhJ%2BH%2B7SBiyHY6%2FOl5b2LdRos6%2Frsd7BUpA5ocvFt";
const googleMapLink = "https://maps.app.goo.gl/sjHWmdCSJzKq4fv2A";
const viberNumbers = [
  "09-782004472",
  "09-404040677",
  "09-964065567",
];
const toDialNumber = (rawNumber) => rawNumber.replace(/[^\d]/g, "");
const toViberNumber = (rawNumber) => {
  const digits = toDialNumber(rawNumber);
  if (digits.startsWith("0")) {
    return `95${digits.slice(1)}`;
  }
  return digits;
};

export function ContactInfo() {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <section>
      <Box sx={{ textAlign: 'justify', marginLeft: isMobile ? '20px' : '40px', display: 'flex', gap: 2 }}>
        <img src={logo} alt="Mandalay HW logo" style={{ width: 99, objectFit: 'contain' }} />
        <Typography variant="h6" sx={{ alignSelf: 'center', fontFamily: "Amiko" }}>
          Mandalay HW
        </Typography>
      </Box>

      <Divider sx={{ mt: 2, mb: 2 }} />
      <Box sx={{ marginLeft: isMobile ? '20px' : '40px' }}>
        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: isMobile ? '14px' : '16px', marginLeft: isMobile ? 0 : 2 }}>
          Connect With Us
        </Typography>
      </Box>
      <Box sx={{ marginLeft: isMobile ? '20px' : '40px', display: 'flex', flexDirection: 'column', gap: 1, mt: 2 }}>
        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', fontFamily: 'Roboto, sans-serif' }}>
          <img src={locationIcon} alt="Location icon" style={{ width: 20, objectFit: 'contain' }} />
          <Typography variant="body2">
            {address}
            <br />
            {businessHours}
            <br />
            {closedNotes}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', alignItems: 'center' }}>
          <img src={phone} alt="Phone icon" style={{ width: 18, objectFit: 'contain' }} />
          <Typography variant="body2">
            Contact Numbers:{" "}
            {contactNumbers.map((number, index) => (
              <React.Fragment key={number}>
                <Link
                  href={`tel:${toDialNumber(number)}`}
                  sx={{ textDecoration: 'none', color: 'inherit' }}
                >
                  {number}
                </Link>
                {index < contactNumbers.length - 1 && ", "}
              </React.Fragment>
            ))}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', alignItems: 'center' }}>
          <img src={phone} alt="Viber icon" style={{ width: 18, objectFit: 'contain' }} />
          <Typography variant="body2">
            Viber:{" "}
            <Link
              href={viberInviteLink}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                textDecoration: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                padding: '3px 9px',
                borderRadius: '999px',
                backgroundColor: '#7360f2',
                color: '#ffffff',
                fontWeight: 600,
                fontSize: '12px',
                boxShadow: '0 6px 16px rgba(115, 96, 242, 0.25)',
                '&:hover': { backgroundColor: '#5a48e6' },
              }}
            >
              Join our Viber Channel
            </Link>
            {viberNumbers.length > 0 && (
              <>
                {" "}
                {viberNumbers.map((number, index) => (
                  <React.Fragment key={number}>
                    <Link
                      href={`viber://chat?number=${toViberNumber(number)}`}
                      sx={{ textDecoration: 'none', color: 'inherit' }}
                    >
                      {number}
                    </Link>
                    {index < viberNumbers.length - 1 && ", "}
                  </React.Fragment>
                ))}
              </>
            )}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', alignItems: 'center' }}>
          <img src={email} alt="Email icon" style={{ width: 18, objectFit: 'contain' }} />
          <Link href="mailto:mandalaywph258384@gmail.com" sx={{ textDecoration: 'none', color: 'inherit' }}>
            mandalaywph258384@gmail.com
          </Link>
        </Box>
        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', alignItems: 'center' }}>
          <Link
            href="https://www.tiktok.com/@mandalayiron?_r=1&_t=ZS-94NIRz4JYmb"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, textDecoration: 'none', color: 'inherit' }}
            aria-label="TikTok"
            title="TikTok"
          >
            <img src={tiktokIcon} alt="TikTok" style={{ width: 18, height: 18 }} />
            <Typography variant="body2">@mandalayiron</Typography>
          </Link>
        </Box>
        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', alignItems: 'center' }}>
          <Link
            href="https://www.facebook.com/share/1GHAEMComL/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, textDecoration: 'none', color: 'inherit' }}
            aria-label="Facebook"
            title="Facebook"
          >
            <FacebookIcon sx={{ fontSize: 18 }} />
            <Typography variant="body2">Facebook Page</Typography>
          </Link>
        </Box>
        <Box sx={{ display: 'flex', gap: 2, paddingX: 2, fontSize: '12px', alignItems: 'center' }}>
          <Link
            href={googleMapLink}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, textDecoration: 'none', color: 'inherit' }}
            aria-label="Google Map"
            title="Google Map"
          >
            <img src={googleMapsIcon} alt="Google Maps" style={{ width: 18, height: 18 }} />
            <Typography variant="body2">Google Map</Typography>
          </Link>
        </Box>
      </Box>
    </section>
  );
}
